import {apiPostUpload, apiPostUploadImagen} from './api';

export default class ServicioUpload {
  static uploadRAR(archivo) {
    return apiPostUpload('/recibos/upload_rar', archivo);
  }
}
